import { MetaPageConfig } from "./configs.types";

export const metaPageConfigs:  { [key: string]: MetaPageConfig } = {
    "dlouhodoba-pujcka": {
        "title": "Opravdu rychlá půjčka na cokoliv.",
        "description": "",
        variants: {
            v1: {
                "title": "Dlouhodobá půjčka - Peníze můžete mít už do 15 minut.",
                "description": ""
            },
            v2: {
                "title": "Opravdu rychlá půjčka na cokoliv.",
                "description": ""
            },
            v3: {
                "title": "Dlouhodobá půjčka - Okamžité vyřízení a peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "expres-pujcka": {
        "title": "Hledáte opravdu rychlou půjčku?",
        "description": "",
        variants: {
            v1: {
                "title": "Expres půjčka - Peníze do 15 minut.",
                "description": ""
            },
            v2: {
                "title": "Hledáte opravdu rychlou půjčku?",
                "description": ""
            },
            v3: {
                "title": "Expres půjčka - Rychlé peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "hotovostni-pujcka": {
        "title": "Potřebujete půjčku v hotovosti? Získejte půjčku na ruku ještě dnes.",
        "description": "",
        variants: {
            v1: {
                "title": "Hotovostní půjčka - Peníze na ruku ještě dnes.",
                "description": ""
            },
            v2: {
                "title": "Hotovostní půjčka s okamžitým vyřízením.",
                "description": ""
            },
            v3: {
                "title": "Hotovostní půjčka - Rychlé peníze na ruku.",
                "description": ""
            }
        }
    },
    "jak-ziskat-pujcku": {
        "title": "Jak získat půjčku?",
        "description": "<p>Získat nebankovní půjčku pomoci našeho aukčního systému je velmi jednoduché a snadné. Vyplníte jednoduchý formulář a během několika vteřin obdržíte nejvýhodnější nabídky úvěru na trhu. Pokud se vám některá z nabídek bude líbit, můžete se přihlásit do klientské sekce vybraného poskytovatele půjčky a odsouhlasit Smlouvu o úvěru. Po kladném vyřízení vaši žádosti o půjčku, peníze ihned budou poukázány na Váš účet bez zbytečného protahovaní a jiných poplatků.</p><p>Nemáte potvrzení o příjmu, důchodový výměr nebo daňové přiznání právě teď u sebe? Vůbec nevadí, potvrzení o příjmu obvykle není třeba dokládat u žádostí o půjčky do 50&nbsp;000 Kč.</p><p>Pokud bude třeba upřesnit některé informace nebo doložit dodatečné podklady, budeme vás kontaktovat.</p><p>Peníze už jsou téměr vaše</p>",
        variants: {
            v1: {
                "title": "Jak získat půjčku? - Jednoduchý průvodce.",
                "description": "<p>Získat nebankovní půjčku je velmi jednoduché. Vyplníte formulář a během několika vteřin obdržíte nabídky. Peníze budou poukázány na Váš účet bez zbytečných poplatků.</p><p>Peníze už jsou téměr vaše</p>"
            },
            v2: {
                "title": "Jak získat půjčku? - Rychlý průvodce.",
                "description": "<p>Získat půjčku je snadné. Vyplníte formulář a obdržíte nabídky. Peníze na účet bez poplatků.</p><p>Peníze už jsou téměr vaše</p>"
            },
            v3: {
                "title": "Jak získat půjčku? - Jednoduchý návod.",
                "description": "<p>Půjčku získáte jednoduše. Vyplníte formulář a dostanete nabídky. Peníze na účet okamžitě.</p><p>Peníze už jsou téměr vaše</p>"
            }
        }
    },
    "kratkodoby-uver": {
        "title": "Krátkodobá půjčka. Okamžité vyřízení.",
        "description": "",
        variants: {
            v1: {
                "title": "Krátkodobý úvěr - Peníze do 15 minut.",
                "description": ""
            },
            v2: {
                "title": "Krátkodobá půjčka. Okamžité vyřízení.",
                "description": ""
            },
            v3: {
                "title": "Krátkodobý úvěr - Rychlé peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "levna-pujcka": {
        "title": "Hledáte levnou půjčku?",
        "description": "",
        variants: {
            v1: {
                "title": "Levná půjčka - Nejvýhodnější podmínky.",
                "description": ""
            },
            v2: {
                "title": "Levná půjčka s výhodnými podmínkami.",
                "description": ""
            },
            v3: {
                "title": "Levná půjčka - Nejlepší nabídky na trhu.",
                "description": ""
            }
        }
    },
    "mala-pujcka": {
        "title": "Malá půjčka. Okamžité vyřízení.",
        "description": "",
        variants: {
            v1: {
                "title": "Malá půjčka - Peníze do 15 minut.",
                "description": ""
            },
            v2: {
                "title": "Malá půjčka. Okamžité vyřízení.",
                "description": ""
            },
            v3: {
                "title": "Malá půjčka - Rychlé peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "mikropujcka-bez-registru": {
        "title": "Mikropůjčka s okamžitým vyřízením.",
        "description": "",
        variants: {
            v1: {
                "title": "Mikropůjčka bez registru - Okamžité vyřízení.",
                "description": ""
            },
            v2: {
                "title": "Mikropůjčka bez registru s rychlým vyřízením.",
                "description": ""
            },
            v3: {
                "title": "Mikropůjčka bez registru - Peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "mobilni-pujcka": {
        "title": "Půjčka přes mobilní telefon? Jednoduchá žádost. Okamžité vyřízení.",
        "description": "",
        variants: {
            v1: {
                "title": "Mobilní půjčka - Jednoduchá žádost přes telefon.",
                "description": ""
            },
            v2: {
                "title": "Půjčka přes mobilní telefon? Okamžité vyřízení.",
                "description": ""
            },
            v3: {
                "title": "Mobilní půjčka - Rychlé peníze přes telefon.",
                "description": ""
            }
        }
    },
    "nebankovni-uver": {
        "title": "Potřebujete nebankovní úvěr?",
        "description": "",
        variants: {
            v1: {
                "title": "Nebankovní úvěr - Peníze do 15 minut.",
                "description": ""
            },
            v2: {
                "title": "Potřebujete nebankovní úvěr?",
                "description": ""
            },
            v3: {
                "title": "Nebankovní úvěr - Rychlé peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "nejcastejsi-otazky": {
        "title": "Nejčastější otázky",
        "description": "",
        variants: {
            v1: {
                "title": "Nejčastější otázky - FAQ.",
                "description": ""
            },
            v2: {
                "title": "Nejčastější otázky a odpovědi.",
                "description": ""
            },
            v3: {
                "title": "Nejčastější otázky - Často kladené dotazy.",
                "description": ""
            }
        }
    },
    "nejlepsi-pujcka": {
        "title": "Hledáte výhodnou půjčku? Najdeme pro vás vhodnou variantu.",
        "description": "",
        variants: {
            v1: {
                "title": "Nejlepší půjčka - Najdeme nejvýhodnější variantu.",
                "description": ""
            },
            v2: {
                "title": "Hledáte výhodnou půjčku? Najdeme pro vás vhodnou variantu.",
                "description": ""
            },
            v3: {
                "title": "Nejlepší půjčka - Porovnání nabídek na trhu.",
                "description": ""
            }
        }
    },
    "nejlevnejsi-pujcka": {
        "title": "Hledáte levnou půjčku? U nás si půjčite nejvýhodněji.",
        "description": "",
        variants: {
            v1: {
                "title": "Nejlevnější půjčka - Nejvýhodnější podmínky.",
                "description": ""
            },
            v2: {
                "title": "Hledáte levnou půjčku? Najdeme pro vás vhodnou variantu.",
                "description": ""
            },
            v3: {
                "title": "Nejlevnější půjčka - Nejlepší ceny na trhu.",
                "description": ""
            }
        }
    },
    "nejvyhodnejsi-pujcka": {
        "title": "Hledáte výhodnou půjčku? Najdeme pro vás vhodnou variantu.",
        "description": "",
        variants: {
            v1: {
                "title": "Nejvýhodnější půjčka - Najdeme nejlepší variantu.",
                "description": ""
            },
            v2: {
                "title": "Hledáte výhodnou půjčku? Najdeme pro vás vhodnou variantu.",
                "description": ""
            },
            v3: {
                "title": "Nejvýhodnější půjčka - Porovnání všech nabídek.",
                "description": ""
            }
        }
    },
    "okamzita-pujcka": {
        "title": "Potřebujete peníze okamžitě? Není problém!",
        "description": "",
        variants: {
            v1: {
                "title": "Okamžitá půjčka - Peníze do 15 minut.",
                "description": ""
            },
            v2: {
                "title": "Potřebujete peníze okamžitě? Není problém!",
                "description": ""
            },
            v3: {
                "title": "Okamžitá půjčka - Rychlé peníze bez čekání.",
                "description": ""
            }
        }
    },
    "porovnani-uveru": {
        "title": "Srovnejte si u nás ceny půjček.",
        "description": "",
        variants: {
            v1: {
                "title": "Porovnání úvěrů - Najdeme nejlepší variantu.",
                "description": ""
            },
            v2: {
                "title": "Srovnejte si u nás ceny půjček.",
                "description": ""
            },
            v3: {
                "title": "Porovnání úvěrů - Kompletní přehled nabídek.",
                "description": ""
            }
        }
    },
    "pujcka-10-000-Kc": {
        "title": "Půjčte si 10 000 Kč. Individuální posouzení.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka 10 000 Kč - Bez registru a potvrzení příjmů.",
                "description": ""
            },
            v2: {
                "title": "Opravdu rychlá půjčka na cokoliv.",
                "description": ""
            },
            v3: {
                "title": "Půjčka 10 000 Kč - Peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "pujcka-20-000-Kc": {
        "title": "Půjčte si 20 000 Kč. Individuální posouzení.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka 20 000 Kč - Bez registru a potvrzení příjmů.",
                "description": ""
            },
            v2: {
                "title": "Opravdu rychlá půjčka na cokoliv.",
                "description": ""
            },
            v3: {
                "title": "Půjčka 20 000 Kč - Peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "pujcka-50-000-Kc": {
        "title": "Půjčte si 50 000 Kč. Individuální posouzení.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka 50 000 Kč - Bez registru a potvrzení příjmů.",
                "description": ""
            },
            v2: {
                "title": "Opravdu rychlá půjčka na cokoliv.",
                "description": ""
            },
            v3: {
                "title": "Půjčka 50 000 Kč - Peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "pujcka-100-000-Kc": {
        "title": "Půjčte si 100 000 Kč. Individuální posouzení.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka 100 000 Kč - Bez registru a potvrzení příjmů.",
                "description": ""
            },
            v2: {
                "title": "Opravdu rychlá půjčka na cokoliv.",
                "description": ""
            },
            v3: {
                "title": "Půjčka 100 000 Kč - Peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "pujcka-150-000-Kc": {
        "title": "Půjčte si 150 000 Kč. Bez registru a potvrzení příjmů.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka 150 000 Kč - Bez registru a potvrzení příjmů.",
                "description": ""
            },
            v2: {
                "title": "Opravdu rychlá půjčka na cokoliv.",
                "description": ""
            },
            v3: {
                "title": "Půjčka 150 000 Kč - Peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "pujcka-2000-Kc": {
        "title": "Půjčte si 2 000 Kč. Individuální posouzení.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka 2 000 Kč - Bez registru a potvrzení příjmů.",
                "description": ""
            },
            v2: {
                "title": "Půjčka 2 000 Kč s rychlým vyřízením.",
                "description": ""
            },
            v3: {
                "title": "Půjčka 2 000 Kč - Peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "pujcka-2-000-Kc": {
        "title": "Půjčte si 2 000 Kč. Individuální posouzení.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka 2 000 Kč - Bez registru a potvrzení příjmů.",
                "description": ""
            },
            v2: {
                "title": "Půjčka 2 000 Kč s rychlým vyřízením.",
                "description": ""
            },
            v3: {
                "title": "Půjčka 2 000 Kč - Peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "pujcka-3000-Kc": {
        "title": "Půjčte si 3 000 Kč. Individuální posouzení.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka 3 000 Kč - Bez registru a potvrzení příjmů.",
                "description": ""
            },
            v2: {
                "title": "Půjčka 3 000 Kč s rychlým vyřízením.",
                "description": ""
            },
            v3: {
                "title": "Půjčka 3 000 Kč - Peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "pujcka-3-000-Kc": {
        "title": "Půjčte si 3 000 Kč. Individuální posouzení.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka 3 000 Kč - Bez registru a potvrzení příjmů.",
                "description": ""
            },
            v2: {
                "title": "Půjčka 3 000 Kč s rychlým vyřízením.",
                "description": ""
            },
            v3: {
                "title": "Půjčka 3 000 Kč - Peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "pujcka-5000-Kc": {
        "title": "Půjčte si 5 000 Kč. Individuální posouzení.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka 5 000 Kč - Bez registru a potvrzení příjmů.",
                "description": ""
            },
            v2: {
                "title": "Půjčka 5 000 Kč s rychlým vyřízením.",
                "description": ""
            },
            v3: {
                "title": "Půjčka 5 000 Kč - Peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "pujcka-5-000-Kc": {
        "title": "Půjčte si 5 000 Kč. Individuální posouzení.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka 5 000 Kč - Bez registru a potvrzení příjmů.",
                "description": ""
            },
            v2: {
                "title": "Půjčka 5 000 Kč s rychlým vyřízením.",
                "description": ""
            },
            v3: {
                "title": "Půjčka 5 000 Kč - Peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "pujcka-bez-prijmu": {
        "title": "Hledáte půjčku? Okamžité vyřízení.",
        "description": "",
        variants: {
            v1: {
                "title": "Hledáte půjčku? Okamžité vyřízení.",
                "description": ""
            },
            v2: {
                "title": "Hledáte půjčku? Okamžité vyřízení.",
                "description": ""
            },
            v3: {
                "title": "Půjčka bez příjmů - Peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "pujcka-bez-registru": {
        "title": "Hledáte půjčku? Okamžité vyřízení.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka bez registru - Okamžité vyřízení.",
                "description": ""
            },
            v2: {
                "title": "Hledáte půjčku? Okamžité vyřízení.",
                "description": ""
            },
            v3: {
                "title": "Půjčka bez registru - Peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "pujcka-do-15-minut": {
        "title": "Hledáte opravdu rychlou půjčku?",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka do 15 minut - Stačí vyplnit formulář.",
                "description": ""
            },
            v2: {
                "title": "Hledáte opravdu rychlou půjčku?",
                "description": ""
            },
            v3: {
                "title": "Půjčka do 15 minut - Rychlé vyřízení online.",
                "description": ""
            }
        }
    },
    "pujcka-ihned": {
        "title": "Potřebujete peníze ještě dnes? Okamžité vyřízení.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka ihned - Peníze ještě dnes.",
                "description": ""
            },
            v2: {
                "title": "Potřebujete peníze ještě dnes? Okamžité vyřízení.",
                "description": ""
            },
            v3: {
                "title": "Půjčka ihned - Rychlé peníze ještě dnes.",
                "description": ""
            }
        }
    },
    "pujcka-na-md": {
        "title": "Půjčka vhodná pro ženy na MD.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka vhodná pro ženy na MD.",
                "description": ""
            },
            v2: {
                "title": "Půjčka vhodná pro ženy na MD.",
                "description": ""
            },
            v3: {
                "title": "Půjčka na MD - Stačí pouze občanský průkaz.",
                "description": ""
            }
        }
    },
    "pujcka-na-op": {
        "title": "Půjčka na OP? Jednoduše! Okamžité vyřízení.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka na OP - Jednoduše a rychle.",
                "description": ""
            },
            v2: {
                "title": "Půjčka na OP? Jednoduše! Okamžité vyřízení.",
                "description": ""
            },
            v3: {
                "title": "Půjčka na OP - Stačí pouze občanský průkaz.",
                "description": ""
            }
        }
    },
    "pujcka-na-ruku": {
        "title": "Potřebujete půjčku na ruku?",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka na ruku - Peníze do 15 minut.",
                "description": ""
            },
            v2: {
                "title": "Půjčka na ruku s okamžitým vyřízením.",
                "description": ""
            },
            v3: {
                "title": "Půjčka na ruku - Rychlé peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "pujcka-na-ucet": {
        "title": "Opravdu rychlá půjčka na cokoliv. Peníze obdržíte na bankovní účet.",
        "description": "",
        variants: {
            v1: {
                "title": "Opravdu rychlá půjčka na cokoliv. Peníze obdržíte na bankovní účet.",
                "description": ""
            },
            v2: {
                "title": "Opravdu rychlá půjčka na cokoliv. Peníze obdržíte na bankovní účet.",
                "description": ""
            },
            v3: {
                "title": "Půjčka na účet - Rychlé peníze na účet.",
                "description": ""
            }
        }
    },
    "pujcka-pro-lidi-v-insolvenci": {
        "title": "Opravdu rychlá půjčka na cokoliv. Peníze obdržíte na bankovní účet.",
        "description": "",
        variants: {
            v1: {
                "title": "Opravdu rychlá půjčka na cokoliv. Peníze obdržíte na bankovní účet.",
                "description": ""
            },
            v2: {
                "title": "Půjčka na účet s rychlým převodem.",
                "description": ""
            },
            v3: {
                "title": "Půjčka na účet - Rychlé peníze na účet.",
                "description": ""
            }
        }
    },
    "pujcka-online-na-ucet": {
        "title": "Požádat o půjčku online? Získejte půjčku ještě dnes.",
        "description": "",
        variants: {
            v1: {
                "title": "Online půjčka na účet - Získejte půjčku ještě dnes.",
                "description": ""
            },
            v2: {
                "title": "Požádat o půjčku online? Získejte půjčku ještě dnes.",
                "description": ""
            },
            v3: {
                "title": "Online půjčka na účet - Peníze ještě dnes.",
                "description": ""
            }
        }
    },
    "pujcka-online": {
        "title": "Půjčka online",
        "description": "<p>Možná jste slyšeli o možnosti získat online půjčku, ale váháte? Před zvažováním půjčky je důležité důkladně porozumět jejím podmínkám, včetně úrokových sazeb, poplatků a důsledků nesplácení. Tyto půjčky mohou být užitečné v situacích, kdy je nutné řešit neočekávané finanční potřeby. Před podáním žádosti se však ujistěte, že máte jasný plán splácení.</p><p>Pokud splníte všechny podmínky dané poskytovatelem, může být žádost o půjčku schválena ve stejný den a peníze zaslány na váš účet. Před podepsáním smlouvy si pečlivě přečtěte všechny podmínky a porovnejte různé nabídky. Můžete také zvážit konzultaci s finančním poradcem, abyste si byli jisti, že je půjčka pro vaši situaci vhodná.</p><p>Peníze už jsou téměr vaše</p>",
        variants: {
            v1: {
                "title": "Online půjčka - Jednoduché vyřízení přes internet.",
                "description": "<p>Online půjčka je moderní způsob získání financí. Před zvažováním půjčky je důležité porozumět podmínkám. Tyto půjčky mohou pomoci při neočekávaných výdajích.</p><p>Peníze už jsou téměr vaše</p>"
            },
            v2: {
                "title": "Online půjčka - Rychlé vyřízení přes internet.",
                "description": "<p>Online půjčka nabízí rychlé řešení finančních potřeb. Důležité je porozumět všem podmínkám před podáním žádosti.</p><p>Peníze už jsou téměr vaše</p>"
            },
            v3: {
                "title": "Online půjčka - Moderní způsob získání peněz.",
                "description": "<p>Online půjčka je rychlý způsob získání financí. Před podáním žádosti si pečlivě přečtěte všechny podmínky.</p><p>Peníze už jsou téměr vaše</p>"
            }
        }
    },
    "pujcka-pred-vyplatou": {
        "title": "Hledáte půjčku před výplatou? Okamžité vyřízení.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka před výplatou - Okamžité vyřízení.",
                "description": ""
            },
            v2: {
                "title": "Hledáte půjčku před výplatou? Okamžité vyřízení.",
                "description": ""
            },
            v3: {
                "title": "Půjčka před výplatou - Peníze do výplaty.",
                "description": ""
            }
        }
    },
    "pujcka-pro-duchodce": {
        "title": "Půjčka vhodná pro důchodce.",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka vhodná pro důchodce.",
                "description": ""
            },
            v2: {
                "title": "Půjčka vhodná pro důchodce.",
                "description": ""
            },
            v3: {
                "title": "Půjčka pro důchodce - Vhodné podmínky pro seniory.",
                "description": ""
            }
        }
    },
    "pujcka-pro-kazdeho": {
        "title": "Půjčka na míru",
        "description": "<p>Nebankovní půjčky mohou být dostupnou možností pro ty, kteří potřebují řešit neočekávané finanční situace. Tento typ půjčky vyžaduje pečlivé zvážení a důkladné seznámení se s jejími podmínkami, včetně úrokových sazeb, poplatků a důsledků případného nesplácení. Před podáním žádosti se ujistěte, že máte jasný plán splácení a rozumíte všem povinnostem, které s úvěrem souvisejí.</p><p>Pro získání půjčky je nutné splnit základní podmínky, které mohou zahrnovat věk mezi 18 a 75 lety, občanství České republiky a vlastnictví bankovního účtu. Před podpisem smlouvy doporučujeme důkladně prostudovat všechny její náležitosti a případně se poradit s finančním odborníkem.</p><p>Pokud chcete zjistit, jaké jsou vaše možnosti, můžete využít online formulář na našich webových stránkách. Po odeslání žádosti systém zpracuje informace a poskytne vám přehled nabídek odpovídajících vašim požadavkům. Vždy doporučujeme porovnat více možností a zvolit tu, která nejlépe vyhovuje vaší finanční situaci.</p><p>Peníze už jsou téměr vaše</p>",
        variants: {
            v1: {
                "title": "Půjčka pro každého - Individuální přístup.",
                "description": "<p>Nebankovní půjčky pro každého. Důležité je pečlivě zvážit podmínky a mít plán splácení. Pro získání půjčky je nutné splnit základní podmínky.</p><p>Peníze už jsou téměr vaše</p>"
            },
            v2: {
                "title": "Půjčka na míru",
                "description": "<p>Půjčka pro každého s flexibilními podmínkami. Před podáním žádosti se ujistěte, že rozumíte všem povinnostem.</p><p>Peníze už jsou téměr vaše</p>"
            },
            v3: {
                "title": "Půjčka pro každého - Dostupné financování.",
                "description": "<p>Dostupná půjčka pro každého. Využijte online formulář pro zjištění vašich možností.</p><p>Peníze už jsou téměr vaše</p>"
            }
        }
    },
    "pujcka-s-exekuci": {
        "title": "Hledáte půjčku a máte exekuci? Není problém!",
        "description": "",
        variants: {
            v1: {
                "title": "Půjčka s exekucí - Peníze do 15 minut.",
                "description": ""
            },
            v2: {
                "title": "Hledáte půjčku a máte exekuci? Není problém!",
                "description": ""
            },
            v3: {
                "title": "Půjčka s exekucí - Rychlé peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "pujcky-problemovym-klientum": {
        "title": "Půjčka s individuálním posouzením",
        "description": "<p>Pokud jste se v minulosti dostali do registru dlužníků, může být složitější získat úvěr od banky za standardních podmínek. V takové situaci je důležité důkladně zvážit své možnosti a pečlivě se seznámit se všemi podmínkami půjčky, včetně výše úrokových sazeb, poplatků a případných důsledků nesplácení. Odpovědné rozhodování o úvěru je zásadní pro zajištění vaší finanční stability.</p><p>Některé nebankovní společnosti nabízejí úvěry s flexibilnějšími podmínkami, jako je možnost odkladu splátek nebo předčasného splacení bez sankcí. Přesto je důležité předem posoudit svou schopnost splácet a plně porozumět smluvním podmínkám.</p><p>Chcete-li zjistit, jaké možnosti financování jsou pro vás k dispozici, můžete využít náš aukční systém, který vám umožní porovnat nabídky od různých poskytovatelů. Vyplněním online formuláře obdržíte přehled nabídek, které odpovídají vašim požadavkům. Doporučujeme, abyste před přijetím jakékoli nabídky konzultovali možnosti s odborníkem a ujistili se, že je úvěr vhodný pro vaši situaci.</p><p>Při sjednávání půjčky je důležité mít na paměti principy odpovědného půjčování. Nezapomeňte posoudit celkové náklady úvěru, zajistit si dostatečné finanční rezervy a zvážit dlouhodobý dopad na vaši finanční situaci.</p><p>Peníze už jsou téměr vaše</p>",
        variants: {
            v1: {
                "title": "Půjčka pro problematické klienty - Individuální posouzení.",
                "description": "<p>Půjčka pro problematické klienty s individuálním posouzením. Důležité je důkladně zvážit možnosti a porozumět podmínkám.</p><p>Peníze už jsou téměr vaše</p>"
            },
            v2: {
                "title": "Půjčka s individuálním posouzením",
                "description": "<p>Flexibilní půjčka pro problematické klienty. Některé společnosti nabízejí úvěry s flexibilnějšími podmínkami.</p><p>Peníze už jsou téměr vaše</p>"
            },
            v3: {
                "title": "Půjčka pro problematické klienty - Možnosti financování.",
                "description": "<p>Možnosti financování pro problematické klienty. Využijte náš systém pro porovnání nabídek.</p><p>Peníze už jsou téměr vaše</p>"
            }
        }
    },
    "rychla-pujcka": {
        "title": "Hledáte opravdu rychlou půjčku?",
        "description": "",
        variants: {
            v1: {
                "title": "Rychlá půjčka - Peníze do 15 minut.",
                "description": ""
            },
            v2: {
                "title": "Hledáte opravdu rychlou půjčku?",
                "description": ""
            },
            v3: {
                "title": "Rychlá půjčka - Rychlé peníze do 15 minut.",
                "description": ""
            }
        }
    },
    "sms-pujcka": {
        "title": "SMS půjčka přes mobilní telefon? Okamžité vyřízení.",
        "description": "",
        variants: {
            v1: {
                "title": "SMS půjčka - Přes mobilní telefon.",
                "description": ""
            },
            v2: {
                "title": "SMS půjčka přes mobilní telefon? Okamžité vyřízení.",
                "description": ""
            },
            v3: {
                "title": "SMS půjčka - Rychlé peníze přes telefon.",
                "description": ""
            }
        }
    },
    "pujcka-pro-podnikatele": {
        "title": "GOODFIN - Online půjčka pro podnikatele a OSVČ",
        "description": "",
        "metaDescription": "Podnikatelský úvěr až 150 000 Kč. Rychlá online žádost, minimum administrativy a rychlé schválení pro živnostníky a firmy.",
        variants: {
            v1: {
                "title": "GOODFIN - Online půjčka pro podnikatele a OSVČ",
                "description": "",
                "metaDescription": "Podnikatelský úvěr až 150 000 Kč. Rychlá online žádost, minimum administrativy a rychlé schválení pro živnostníky a firmy."
            }
        }
    }
};
